///Dominio LocalHost Prueba
export let Settings = {
  CASLOGIN: process.env.REACT_APP_CASLOGIN,
  CASLOGOUT: process.env.REACT_APP_CASLOGOUT,
  MY_APLICATION: process.env.REACT_APP_MY_APLICATION,
  LOGOUT_REDIRECT: process.env.REACT_APP_LOGOUT_REDIRECT,
  LOGOUT_CORREO: process.env.REACT_APP_LOGOUT_CORREO,
  VALIDATE_TICKET: process.env.REACT_APP_VALIDATE_TICKET,
};
